var borders_default = {
  "borderT": "ZftGt",
  "borderB": "NAgQk",
  "borderL": "woM1-",
  "borderR": "hmzmE",
  "borderColorOverride": "Jjjjl"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
